// Custom icon static resources

import {
  BulbOutline,
  ExceptionOutline,
  InfoOutline,
  LinkOutline,
  ProfileOutline,
  ApartmentOutline,
  BankOutline,
  EyeInvisibleOutline,
  CopyrightCircleOutline,
  CloudServerOutline,
  DollarCircleOutline,
  ShoppingOutline,
  FolderOutline,
  FolderOpenOutline,
  AccountBookOutline,
  ContactsOutline,
  WarningOutline,
  ExclamationCircleOutline,
} from '@ant-design/icons-angular/icons'

export const ICONS = [
  InfoOutline,
  BulbOutline,
  ProfileOutline,
  ExceptionOutline,
  LinkOutline,
  ApartmentOutline,
  BankOutline,
  EyeInvisibleOutline,
  CopyrightCircleOutline,
  CloudServerOutline,
  DollarCircleOutline,
  ShoppingOutline,
  FolderOutline,
  FolderOpenOutline,
  AccountBookOutline,
  ContactsOutline,
  WarningOutline,
  ExclamationCircleOutline,
]
